module.exports = __webpack_public_path__ + "img/logo-small.19622e95.png";